<template>
  <div class="login">
    <div class="login_content">
      <el-row class="login_title">
        <el-col :span="8">
          <div class="grid-content bg-purple"><img src="@/assets/images/city_login_logo.png" /></div>
        </el-col>
        <el-col :span="16">
          <div class="grid-content bg-purple-light"><h2>智售云</h2></div>
        </el-col>
      </el-row>
      <div class="login_form" v-if="loginType === 1">
        <h3>密码登录</h3>
        <el-form :model="ruleForm" status-icon ref="ruleForm" class="demo-ruleForm" @submit.native.prevent>
          <el-form-item prop="userName">
            <el-input
              type="text"
              v-model="ruleForm.userName"
              placeholder="请输入登录账号、手机号或邮箱"
              prefix-icon="el-icon-user"
              autocomplete="off"
              tabindex="1"
              @keyup.enter.native="submitForm('ruleForm')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              type="password"
              v-model="ruleForm.password"
              placeholder="请输入登录密码"
              prefix-icon="el-icon-lock"
              autocomplete="off"
              tabindex="2"
              @keyup.enter.native="submitForm('ruleForm')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="code" class="captcha">
            <div class="captcha">
              <el-input
                v-model="ruleForm.code"
                style="width: 225px"
                prefix-icon="el-icon-message"
                placeholder="请输入验证码"
                type="text"
                tabindex="3"
                @keyup.enter.native="submitForm('ruleForm')"
              />
              <div @click="getCaptcha()"><img style="height: 36px; margin-left: 10px" :src="captchatImg" /></div>
            </div>
          </el-form-item>
          <el-form-item style="margin-bottom: 10px">
            <el-button type="primary" @click="submitForm('ruleForm')" @keyup.enter.native="submitForm('ruleForm')" style="width: 100%"
              >登录
            </el-button>
          </el-form-item>
          <el-form-item>
            <router-link :to="{ path: '/forget_the_password' }" style="color: #409eff; text-decoration: underline"> 忘记密码 </router-link>
          </el-form-item>
        </el-form>
        <el-button type="text" @click="toScan"><img src="@/assets/images/oms_er.png" class="position_bottom" /> </el-button>
        <div class="login_title_er">
          <p><i class="login_wei">扫码登录</i></p>
        </div>
        <div class="login_title_guan" v-if="!isWechat">
          <h4>扫码使用</h4>
          <i>手机运营助手</i>
          <img src="@/assets/images/wei_er.jpg"/>
          <p>微信小程序</p>
        </div>
      </div>
      <!--        扫码-->
      <div class="login_form" v-if="loginType === 0">
        <h3 style="text-align: center">微信扫码登录</h3>
        <div class="demo-ruleForm" style="text-align: center">
          <!--                    <p class="info_er">请使用微信扫描二维码，进行身份验证</p>-->
          <vue-qr v-if="loginResult === 0" :text="qrCodeText" :size="220"></vue-qr>
          <img v-if="loginResult === 0"  class="overlay-image" style="z-index: 999" :src="imageUrl">
          <img v-else-if="loginResult === 1" class="er_login" src="@/assets/images/success_er.png"  alt=""/>
          <img v-else-if="loginResult === 3" class="er_login" src="@/assets/images/usecode.png" @click="getLoginScan"  alt=""/>

        </div>
        <el-button type="text" @click="toPassword"><img src="@/assets/images/oms_user.png" class="position_bottom" /> </el-button>
        <div class="login_title_er">
          <p><i class="login_wei">密码登录</i></p>
        </div>
        <!--                <div v-if="!isChrome && !isMobile" style="color:darkorange;text-align: center">建议使用Chrome浏览器以确保平台功能正常使用</div>-->
      </div>

      <div style="width: 100%; text-align: center; padding-top: 10px">
        <el-button v-if="isWechat" type="success" @click="weappCreate" style="width: 240px" plain round>点击通过运营助手快捷登录 </el-button>
      </div>
    </div>
    <el-dialog title="选择登录账号" :visible.sync="dialogVisible" custom-class="dia" width="350px">
      <span slot="">
        <el-row
          v-for="item in weappUsers"
          :key="item.managerId"
          style="background-color: rgb(236 238 242); margin-bottom: 10px; border-radius: 5px; padding: 5px"
          @click.native="weappLogin(item.managerId)"
        >
          <el-col :span="3" style="margin-top: 5px; margin-left: 5px; margin-right: 5px">
            <!--            加盟商-->
            <img v-if="item.managerType == 'MAIN'" src="../assets/images/u001.png" class="img-icon" alt="" />
            <img v-else-if="item.managerType == 'ADMIN'" src="../assets/images/u003.png" class="img-icon" alt="" />
            <img v-else src="@/assets/images/26x26.png" class="img-icon" alt="" />
          </el-col>
          <el-col :span="19">
            <el-row>
              <div class="font-34">{{ item.managerRealName }}</div>
            </el-row>
            <el-row>
              <el-col :span="16">
                <div class="font-30">{{ item.managerLoginName }}</div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import vueQr from "vue-qr";
import {getCookie, setCookie} from "../util";
import store from "../store";

export default {
  name: "Login",
  components: { vueQr },
  data() {
    return {
      adPath: "",
      ruleForm: {
        userName: "",
        password: "",
        code: "",
        key: ""
      },
      code: null,
      captchatImg: "",
      isChrome: navigator.userAgent.indexOf("Chrome") >= 0,
      isMobile: /mobile|android|iphone|ipod|phone ipad/i.test(navigator.userAgent.toLowerCase()),
      isWechat: navigator.userAgent.toLowerCase().indexOf("micromessenger") >= 0,
      dialogVisible: false,
      weappUsers: [],
      loginType: 0,
      scanId: "",
      redirect: "",
      isActive: true,
      loginResult: 0,
      waitScanNum: 0,
      imageUrl: "/img/logo/logo.png",
      qrCodeText: ""
    };
  },
  methods: {
    getCaptcha() {
      const captchatImg =
        "data:image/png;base64,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";
      this.get("/authority/get_code")
        .then((res) => {
          this.captchatImg = res.data.code;
          this.ruleForm.key = res.data.key;
          this.ruleForm.code = "";
          clearTimeout(this.timerId);
          this.timerId = setTimeout(() => {
            this.captchatImg = captchatImg;
            this.ruleForm.key = "";
            this.ruleForm.code = "";
          }, 2 * 60 * 1000);
        })
        .catch((res) => {
          if (res.errorCode == 6) {
            this.$router.replace(
              {
                path: this.redirect ? this.redirect : "/"
              },
              () => {},
              () => {}
            );
          } else {
            this.captchatImg = captchatImg;
          }
        });
    },
    async getLoginScan() {
      const that = this;
      this.loginResult = 0;
      this.qrCodeText = "";
      this.waitScanNum = 0;
      let result = await this.post("authority/qrcode/create_scan").then(
        (res) => {
          that.scanId = res.data.scanId;
          that.qrCodeText = res.data.url;
          that.isActive = true;
          return true;
        },
        (res) => {
          if (res.errorCode == 6) {
            this.$router.replace(
              {
                path: this.redirect ? this.redirect : "/"
              },
              () => {},
              () => {}
            );
          }
          return null;
        }
      );
      if (result) {
        this.longPollScan();
      } else {
        this.loginResult = 3;
      }
    },
    longPollScan() {
      if (!this.isActive && !this.scanId) {
        return false;
      }
      if (this.waitScanNum > 10) {
        this.closeScan();
        return false;
      }
      this.waitScanNum++;
      let that = this;
      // let config = {timeout: 25000};
      let config = {
        timeout: 25000,
        cancelToken: new axios.CancelToken(function executor(cancel) {
          return (that.cancelToken = cancel);
        })
      };
      this.post(
        "authority/qrcode/wait_scan",
        {
          scanId: this.scanId
        },
        {},
        config
      ).then(
        (res) => {
          that.cancelToken = null;
          if (!that.isActive) {
            return;
          }
          if (res) {
            if (res.errorCode === 0) {
              if (res.data.scan_result === 2) {
                store.commit("clearUserInfo");
                setCookie("last_login_type", 0, 0);
                that.$router.replace(
                  {
                    path: that.redirect ? that.redirect : "/"
                  },
                  () => {},
                  () => {}
                );
                that.isActive = false;
              } else if (res.data.scan_result === 1) {
                that.loginResult = 1;
                that.longPollScan();
              } else if (res.data.scan_result === 0) {
                that.longPollScan();
              }
            } else {
              that.loginResult = 3;
              that.$message({
                message: res.message,
                type: "error",
                showClose: true
              });
            }
          } else {
            that.loginResult = 3;
            that.$message({
              message: "二维码已失效，请点击刷新二维码后重试",
              type: "warning"
            });
          }
        },
        (res) => {
          that.cancelToken = null;
          that.loginResult = 3;
        }
      );
    },
    closeScan() {
      this.isActive = false;
      this.qrCodeText = "";
      this.loginResult = 3;
      let config = { headers: { "Content-Type": "application/x-www-form-urlencoded; charset=utf-8" } };
      this.post("authority/qrcode/close_scan", {}, { scanId: this.scanId }, config).then(
        () => {},
        () => {}
      );
      if (this.cancelToken) this.cancelToken();
    },
    async weappCreate() {
      if (this.isWechat) {
        if (this.code) {
          if (await this.weappQuery(this.code)) {
            return;
          }
        }
        this.post("authority/weapp/create").then((res) => {
          if (res.errorCode == 0) {
            this.scanId = res.data.code;
            window.location.href = res.data.redirectUrl;
            return true;
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    weappQuery(code) {
      return this.get("/authority/weapp/query", { code }).then((res) => {
        if (res.errorCode == 0) {
          if (res.data.length == 0) {
            this.$message.error("运营助手未登录账号");
          } else if (res.data.length == 1) {
            this.weappLogin(res.data[0].managerId);
          } else {
            this.weappUsers = res.data;
            this.dialogVisible = true;
          }
          return true;
        } else if (res.errorCode == 10202) {
          this.code = null;
          this.weappCreate();
        } else {
          this.$message.error(res.message);
        }
        return false;
      });
    },
    weappLogin(managerId) {
      this.post("authority/weapp/login", { code: this.$route.query.code, managerId: managerId }).then((res) => {
        if (res.errorCode == 0) {
          store.commit("clearUserInfo");
          this.$router.replace(
            {
              path: this.redirect ? this.redirect : "/"
            },
            () => {},
            () => {}
          );
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      });
    },
    submitForm(formName) {
      if (this.ruleForm.userName == "") {
        this.$message.error("请输入登录账号");
        return;
      } else if (this.ruleForm.password == "") {
        this.$message.error("请输入登录密码");
        return;
      } else if (this.ruleForm.code == "") {
        this.$message.error("请输入验证码");
        return;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {
            loginName: this.ruleForm.userName,
            loginPwd: this.ruleForm.password,
            code: this.ruleForm.code,
            key: this.ruleForm.key
          };
          if (this.loading) return;
          this.loading = true;
          this.post("authority/login", param).then(
            (res) => {
              this.loading = false;
              store.commit("clearUserInfo");
              setCookie("access-token", res.data.token);
              setCookie("last_login_type", 1, 0);
              this.$router.replace(
                {
                  path: this.redirect ? this.redirect : "/"
                },
                () => {},
                () => {}
              );
            },
            () => {
              this.getCaptcha();
              this.loading = false;
            }
          );
        }
      });
    },
    selfMotion: function () {},
    toScan() {
      this.loginType = 0;
      this.getLoginScan();
    },
    toPassword() {
      this.loginType = 1;
      this.getCaptcha();
      this.closeScan();
    }
  },
  created() {
    this.redirect = this.$route.query.redirect;
    if (this.$route.query.code) {
      this.code = this.$route.query.code;
      this.weappQuery(this.code);
    }
  },
  mounted() {
    if (this.redirect && window.__wxjs_environment === "miniprogram") {
      //运营助手打开的，携带token
      let url = new URL(window.location.host + this.redirect);
      let token = url.searchParams.get("token");
      if (token) {
        store.commit("clearUserInfo");
        setCookie("access-token", token);
        this.redirect = this.redirect.replace("token=" + token, "");
      }
      this.$router.replace(
        {
          path: this.redirect ? this.redirect : "/"
        },
        () => {},
        () => {}
      );
      return;
    }
    if (getCookie("last_login_type") == 1) {
      this.loginType = 1;
      this.getCaptcha();
    } else {
      this.loginType = 0;
      this.getLoginScan();
    }
  },
  destroyed() {
    if (this.loginType == 0) {
      this.closeScan();
    }
  }
};
</script>
<style scoped>
.overlay-image {
  position: absolute;
  top: 46%;
  left: 46%;
  width: 36px; /* 自适应容器宽度 */
  height: auto;
  z-index: 999;
}
.captcha {
  display: flex;
  align-items: flex-start;
}

.img-icon {
  width: 30px;
  height: 30px;
}

.font-34 {
  font-size: 16px;
  color: #353535;
}

.font-30 {
  color: #888;
  font-size: 16px;
}
</style>
